import type { CSSProperties } from "react"

export type VideoAspect = { width: number; height: number }

export function isPortraitVideo(width: number, height: number): boolean {
  return width > 0 && height > 0 && height > width
}

export type CarouselFrameOptions = {
  videoAspect: VideoAspect | null
  maxHeightPx: number
  maxWidthPx: number
  landscapeClassName: string
}

export type CarouselFrameResult = {
  className: string
  style?: CSSProperties
}

/**
 * Portrait videos get a frame matching their aspect ratio (capped by maxHeight/maxWidth).
 * Landscape / unknown keep the existing fixed landscape className.
 */
export function carouselFrameProps({
  videoAspect,
  maxHeightPx,
  maxWidthPx,
  landscapeClassName
}: CarouselFrameOptions): CarouselFrameResult {
  if (videoAspect && isPortraitVideo(videoAspect.width, videoAspect.height)) {
    return {
      className: "relative mx-auto overflow-hidden bg-black/5",
      style: {
        height: maxHeightPx,
        width: "auto",
        maxWidth: maxWidthPx,
        aspectRatio: `${videoAspect.width} / ${videoAspect.height}`
      }
    }
  }

  return { className: landscapeClassName }
}

export function videoAspectFromElement(video: HTMLVideoElement): VideoAspect | null {
  const { videoWidth: width, videoHeight: height } = video
  if (width <= 0 || height <= 0) return null
  return { width, height }
}
